<template>
    <main class="app-container">
        <section class="profile loader-block-parent">
            <div v-show="isLoading" class="loader-block">
                <div>
                    <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                </div>
            </div>
            <div class="profile__top">
                <h2>{{ $t('clients.my_clients') }}</h2>
                <div class="my-projects__options">
                    <button v-if="type != 's' && type != 'xs'">
                        <img src="@/assets/icons/sorts.svg" width="24" height="24" :alt="$t('clients.sort')" />{{ $t('clients.sort') }}
                        <div class="list">
                            <div class="list__inner">
                                <ul>
                                    <li v-for="sortType in sortTypes"
                                        @click.prevent="sortClients(sortType)"
                                        :class="{'selected': selectedSortType === sortType}"
                                    >
                                        {{ $t('clients.sort_list.' + sortType) }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </button>
                    <button v-else @click.prevent="showSortList = !showSortList"
                            ref="clickOutsideSort">
                        <img src="@/assets/icons/sorts.svg" width="24" height="24" :alt="$t('clients.sort')" />{{ $t('clients.sort') }}
                        <div v-if="showSortList" class="list">
                            <div v-if="showSortList" class="list__inner">
                                <ul>
                                    <li v-for="sortType in sortTypes"
                                        @click.prevent="sortClients(sortType)"
                                        :class="{'selected': selectedSortType === sortType}"
                                    >
                                        {{ $t('clients.sort_list.' + sortType) }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </button>
                    <button v-if="type != 's' && type != 'xs'">
                        <img src="@/assets/icons/filter.svg" :alt="$t('clients.filter')" />{{ $t('clients.filter') }}
                        <div class="list">
                            <div class="list__inner">
                                <ul>
                                    <li v-for="filterType in filterTypes"
                                        @click.prevent="filterClients(filterType)"
                                        :class="{'selected': selectedFilterType === filterType}"
                                    >
                                        {{ $t('clients.filter_list.' + filterType) }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </button>
                    <button v-else @click.prevent="showFilterList = !showFilterList"
                            ref="clickOutsideFilter">
                        <img src="@/assets/icons/filter.svg" :alt="$t('clients.filter')" />{{ $t('clients.filter') }}
                        <div v-if="showFilterList" class="list">
                            <div v-if="showFilterList" class="list__inner">
                                <ul>
                                    <li v-for="filterType in filterTypes"
                                        @click.prevent="filterClients(filterType)"
                                        :class="{'selected': selectedFilterType === filterType}"
                                    >
                                        {{ $t('clients.filter_list.' + filterType) }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </button>
                </div>
            </div>
            <div class="clients">

                <div class="info-box" v-show="showInfo">
                    <div class="info-box__text">
                        <img src="@/assets/icons/report.svg" alt="" /> <p>{{$t('clients.info_add_new_client')}}.</p>
                    </div>
                    <div class="info-box__close">
                        <button @click="showInfo = false">X</button>
                    </div>
                </div>

                <div v-for="client in clients" class="client">
                    <div class="client__top">
                        <div class="client__name">
                            <div>
                                <UserImage
                                    :src="client.imagePath"
                                    :user="client"
                                    width="50"
                                    height="50"
                                />
                            </div>
                            <p>{{ client.firstName + ' ' + client.lastName }}</p>
                        </div>
                        <div class="client__contact">
                            <p>
                                <img src="@/assets/icons/phone.svg" alt="" />
                                {{ client.phone }}
                            </p>
                            <p>
                                <img
                                    src="@/assets/icons/mail.svg"
                                    alt="Ikonka maila"
                                />{{ client.email }}
                            </p>
                        </div>
                        <div class="client__actions">
                            <button>
                                <img src="@/assets/icons/admin/message.svg" alt="" />
                                <div class="tooltip">Wyślij wiadomość</div>
                            </button>
                            <button>
                                <img src="@/assets/icons/report.svg" alt="" />
                                <div class="tooltip">Zgłoś</div>
                            </button>
                            <button class="client__menu">
                                <div>
                                    <img src="@/assets/icons/more.svg" :alt="$t('clients.delete')" />
                                    <div class="client__menu-list">
                                        <ul>
                                            <li @click.prevent="showDeleteClientDialog(client)">{{ $t('clients.delete') }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </button>
                            <button class="client-details-toggle" @click="toggleClientOpened(client.id)" :class="{'opened': openedClientsIds.includes(client.id)}" data-id="client1">
                                <svg
                                    id="arrow_drop_down-24px"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        id="Path_111"
                                        data-name="Path 111"
                                        d="M0,0H24V24H0Z"
                                        fill="none"
                                    />
                                    <path
                                        id="Path_112"
                                        data-name="Path 112"
                                        d="M7,10l5,5,5-5Z"
                                        fill="#626060"
                                    />
                                </svg>
                                <div class="tooltip">{{ $t('clients.more') }}</div>
                            </button>
                        </div>
                    </div>
                    <div class="client__bottom" :class="{'opened client__bottom--opened': openedClientsIds.includes(client.id)}" id="client1">
                        <h3>Projekty</h3>
                        <div class="client__projects">
                            <div class="client__section" v-for="project in client.projects">
                                <div class="client__section-name"><router-link class="client__section-name" :to="{name: 'project-details', params: {id: project.id}}">{{ project.name }}</router-link></div>
                                <div class="client__section-summary">
                                    <p class="client__section-summary-status">{{ $t('clients.ready') }}</p>
                                    <p class="client__section-summary-progress">{{ project.progress }}%</p>
                                    <div class="progress">
                                        <div class="progress__inner" :style="'width: ' + (project.progress ?? 0) + '%'"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
    <delete-client-modal ref="deleteClientModal" />

</template>

<script>
import UserLayout from "@/layouts/UserLayout";
import {computed, inject, ref} from "vue";
import {storeToRefs} from "pinia";
import {useClientsStore} from "@/stores/user/architect/clients.store";
import router from "@/router";
import DeleteClientModal from "@/components/architect/deleteClientModal";
import userService from "@/services/user.service";
import UserImage from "@/components/image/UserImage.vue";
import breakpointsHelper from "@/helpsers/breakpoints.helper";
import {useClickOutside} from "@/helpsers/click-outside.helpers";
export default {
    name: "MyClients",
    components: {DeleteClientModal, UserLayout, UserImage},
    setup() {
        const clientStore = useClientsStore();
        let { clients, page, onPage, total, isLoading, sortTypes, filterTypes, selectedSortType, selectedFilterType } = storeToRefs(clientStore);
        let showSortList = ref(false);
        let showFilterList = ref(false);
        let openedClientsIds = ref([]);
        const deleteClientModal = ref();
        const emitter = inject('emitter');
        const showInfo = ref(true);
        //Pobieranie rozmiaru ekranu.
        const { width, type } = breakpointsHelper();

        let queryParams = router.currentRoute.value.query;
        if (queryParams) {
            for (let paramName in queryParams) {
                if (paramName === 'page' && page.value !== queryParams[paramName])
                    page.value = queryParams[paramName];
                // if (paramName === 'onPage' && onPage.value !== queryParams[paramName])
                //     onPage.value = queryParams[paramName];
                if (paramName === 'order' && selectedSortType.value !== queryParams[paramName])
                    selectedSortType.value = queryParams[paramName];
                if (paramName === 'filter' && selectedFilterType.value !== queryParams[paramName])
                    selectedFilterType.value = queryParams[paramName];
            }
        }
        clientStore.fetchClients();
        clientStore.fetchSortTypes();

        const pagesNumber = computed(() => {
            if (total.value && onPage.value)
                return Math.ceil(total.value/onPage.value);
            else
                return 1;
        });

        function refreshList() {
            if (page.value > pagesNumber.value)
                page.value = pagesNumber.value;
            if (page.value < 1)
                page.value = 1;
            refreshClientsList();
        }

        function prevPage() {
            if (page.value > 1) {
                page.value = page.value - 1;
                refreshClientsList();
            }
        }

        function nextPage() {
            if (page.value < pagesNumber.value) {
                page.value = page.value + 1;
                refreshClientsList();
            }
        }

        function setCurrentQueryParamsString() {
            let params = '';
            if (page.value >= 1) {
                if (params)
                    params += '&';
                params += `page=${encodeURIComponent(page.value)}`
            }
            // if (onPage.value != 25 && onPage.value > 0) {
            //     if (params)
            //         params += '&';
            //     params += `onPage=${encodeURIComponent(onPage.value)}`
            // }
            if (selectedSortType.value) {
                if (params)
                    params += '&';
                params += `order=${encodeURIComponent(selectedSortType.value)}`
            }
            if (selectedFilterType.value) {
                if (params)
                    params += '&';
                params += `filter=${encodeURIComponent(selectedFilterType.value)}`
            }

            return params;
        }

        emitter.on('clientDeleted', () => {
            refreshClientsList()
        })

        function refreshClientsList() {
            openedClientsIds.value = [];

            let params = setCurrentQueryParamsString();
            if (params)
                history.pushState({}, null, `${router?.currentRoute?.value?.path}?${params}`);
            clientStore.fetchClients();
        }

        function sortClients(type) {
            if (type === selectedSortType.value)
                selectedSortType.value = null;
            else
                selectedSortType.value = type;
            refreshClientsList();
        }

        function filterClients(type) {
            if (type === selectedFilterType.value)
                selectedFilterType.value = null;
            else
                selectedFilterType.value = type;
            refreshClientsList();
        }

        function removeItem(arr, item){
            return arr.filter(f => f !== item)
        }

        function toggleClientOpened(clientId) {
            if (openedClientsIds.value.includes(clientId))
                openedClientsIds.value = removeItem(openedClientsIds.value, clientId);
            else
                openedClientsIds.value.push(clientId);
        }

        function showDeleteClientDialog(clientData) {
            deleteClientModal.value.showModal(clientData)
        }

        const clickOutsideSort = ref('');
        useClickOutside(clickOutsideSort,(e) => {
            showSortList.value = false;
        });

        const clickOutsideFilter = ref('');
        useClickOutside(clickOutsideFilter,(e) => {
            showFilterList.value = false;
        });

        return {
            clients,
            page,
            onPage,
            total,
            pagesNumber,
            refreshList,
            prevPage,
            nextPage,
            isLoading,
            sortTypes,
            sortClients,
            filterClients,
            clickOutsideSort,
            clickOutsideFilter,
            type,
            filterTypes,
            showSortList,
            showFilterList,
            selectedSortType,
            selectedFilterType,
            openedClientsIds,
            toggleClientOpened,
            showDeleteClientDialog,
            deleteClientModal,
            userService,
            showInfo
        }
    }
}
</script>

<style scoped lang="scss">
.my-projects {
    &__options {
        .list {
            z-index: 1;

            li {
                &:hover {
                    color: #ff7366;
                }
                &.selected {
                    color: #ff7366;
                    background-color: #f5e4e3;
                }
            }
        }
    }
}
.client {
    margin: 20px 0;

    &:hover {
        background-color: #F5F5F5;
    }

    &__actions {
        flex-grow: 1;
        flex-basis: 0;

        @media screen and (max-width: 1199px) {
            flex: none;
        }

        button {
            margin-right: 5px;
            margin-top: 5px;
            img {
                width: 24px;
            }
        }
    }

    &__name {
        flex-grow: 1;
        flex-basis: 0;
        @media screen and (max-width: 1199px) {
            flex: none;
        }

        img {
            width: 50px;
            height: 50px;
            border-radius: 50px;
        }
    }

    &__projects {
        max-height: 322px;
        overflow: auto;

        .client__section {
            margin-bottom: 40px;
        }
    }

    &__contact {
        @media screen and (max-width: 1199px) {
            flex: none;
        }
        flex-grow: 2;
        flex-basis: 0;
    }

    &__menu {
        .client__menu-list {
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translate(-50%, 100%);
            background-color: #fff;
            box-shadow: 3px 3px 6px rgb(0 0 0 / 16%);
            display: none;

            ul {
                li {
                    padding: 9px 18px;
                    cursor: pointer;

                    &:not(:last-of-type) {
                        border-bottom: 1px solid #f4f3f3;
                    }

                    &:hover {
                        color: #ff7366;
                    }
                }
            }
        }

        &:hover {
            .client__menu-list {
                display: block;
            }
        }
    }
}

.info-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #353535;
    background: #ffffff 0% 0% no-repeat padding-box;
    max-width: 1120px;
    box-shadow: 0px 3px 6px rgb(0 0 0 / 16%);
    border-radius: 5px;
    padding: 5px 28px;

    &__text {
        display: flex;
        align-items: center;

        img {
            padding-right: 10px;
        }
    }
    &__close {
        button {
            background: transparent;
            border: none;
            outline: none;
            cursor: pointer;
        }
    }
}

</style>
